import type { IPurchaseIntentResponse } from '@escloud/types';
import { Link } from 'react-router';

import { subscribeAccountHref } from '@/lib/onboarding-funnel';

const SECTOR_LABELS: Record<NonNullable<IPurchaseIntentResponse['sector']>, string> = {
    hospital: 'Hospital',
    private_clinic: 'Private clinic',
    medical_device_industry: 'Medical device industry',
    research: 'Research',
    other: 'Other',
};

/** The account-step answers, read-only, with the one way back. */
export function AccountRecallCard({
    intent,
    regionName,
}: {
    intent: IPurchaseIntentResponse;
    regionName: string;
}) {
    const subscriptionFor =
        intent.tenantType === 'organization'
            ? `${intent.organizationName ?? 'Organization'}${intent.sector ? ` · ${SECTOR_LABELS[intent.sector]}` : ''}`
            : 'Myself';

    return (
        <div className="rounded-xl border border-border bg-muted/30 p-5">
            <div className="mb-3 flex items-center justify-between">
                <h2 className="m-0 text-[15px] font-semibold text-foreground">Your account details</h2>
                <Link
                    to={subscribeAccountHref(intent.planId)}
                    className="text-[13px] font-medium text-primary"
                >
                    Edit details
                </Link>
            </div>
            <dl className="m-0 grid grid-cols-[auto_1fr] gap-x-4 gap-y-2 text-sm">
                <dt className="text-muted-foreground">Subscription for</dt>
                <dd className="m-0 text-foreground">{subscriptionFor}</dd>
                <dt className="text-muted-foreground">Data region</dt>
                <dd className="m-0 text-foreground">
                    {regionName} <span className="text-muted-foreground">(permanent)</span>
                </dd>
            </dl>
        </div>
    );
}
